<template>
    <div class="position-box">
      <div class="head">
        <img class="back" src="@/assets/icon_back.png" alt="" @click="back">
        <span>{{$t('wydb.yhkxq')}}</span>
		  </div>
      <div id="repayment" class="bg">
        <div class="repayment-head">
          <div class="t1">{{$t('wydb.bqyhk')}}</div>
          <div class="money">{{(parseFloat(hkCont[0].amount) + parseFloat(hkCont[0].interest)).toFixed(4)}}</div>
          <div class="tips">{{$t('wydb.hktips')}}</div>
        </div>
        <div class="repayment-body">
          <div class="text">{{hkCont[0].start_time_format}} <span>{{$t('wydb.jie')}}</span> {{hkCont[0].amount}}</div>
          <ul>
            <li class="li">
              <div class="t1">{{$t('wydb.bj')}}</div>
              <div class="t1">{{hkCont[0].amount}}</div>
            </li>
            <li class="li">
              <div class="t1">{{$t('wydb.lx')}}</div>
              <div class="t1">{{hkCont[0].interest}}</div>
            </li>
            <li class="li">
              <div class="t1">{{$t('wydb.hkfs')}}</div>
              <div class="t1">{{$t('wydb.dqych')}}</div>
            </li>
          </ul>
          <button class="btn" @click="submit">{{$t('wydb.ljhk')}}</button>
        </div>
      </div>
      <div class="mask" v-show="isMask" @click="close"></div>
      <div class="repayment-alert" v-show="isMask">
        <div class="title">{{$t('wydb.yebzqxcz')}}</div>
        <button class="btn" @click="goCz">{{$t('wydb.qcz')}}</button>
      </div>
    </div>
</template>

<script>
import lrz from "lrz";
export default {
    name: 'repaymet2',
    data () {
        return {
            isLoad: false,
            theme: false,
            isShow: false,
            langText: 'English',
            isMask: false,
            id: '',
            hkCont: [
              {
                no:'',
                interest: 0,
                amount: 0
              }
            ],
            address: '',
            photo_hkpz: '',
            fkjg: ''
        }
    },
    created(){
      this.langText = localStorage.getItem('langText') || 'English';
      this.fkjg = localStorage.getItem('fkjg');
      this.id = this.$route.query.id;
    },
    mounted() {
      this.getMylist();
      this.getChainList()
    },
    methods: {
       back(){
           this.$router.push('/currencyRecord')
       },
       goCz(){
            this.$router.push('/deposit')
        },
        getMylist(){
            let params = {page: 1};
            this.$ajax.get('/web/lendMylist',{params}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/index');
                  },1000)
                  return false
                }
                this.hkCont = resData.filter((item)=>{
                  if(item.id == this.id){
                    return true
                  }
                })
            }).catch(function(err){
                console.log(err)
            })
       },
        getChainList(){
          let params = {
              currency: 'USDT',
              tag:'lend'
          }
          this.$ajax.get('/web/getChainList',{params}).then((res) => {
              let resData = res.data.data;
              this.address = resData[0].address;
          }).catch(function(err){
              console.log(err)
          })
        },
        getLendBack(){
          let params = {
              id:this.id
          }
          this.$ajax.get('/web/lendlist',{params}).then((res) => {
              let resData = res.data;
              if(resData.code == 5){
                this.isMask = true;
              }else{
                this.isMask = false;
              }
          }).catch(function(err){
              console.log(err)
          })
				},
        submit(){
          let params = {
              id: this.id,
              img_reback: ''
          }
          this.$ajax.get('/web/lendBack',{params}).then((res) => {
              let resData = res.data;
              if(resData.code == 5){
                this.isMask = true;
              }else if(resData.code == 0){
                this.$toast.center(this.$t('status.statusText')[2]);
                setTimeout(()=>{
                  this.isMask = false;
                  this.$router.push('/currencyRecord')
                },1500)
              }else if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/index');
                  },1000)
                  return false
              }else{
                that.isMask = false;
              }
          }).catch(function(err){
              console.log(err)
          })
				},
      close(){
        this.isMask = false
      },
      copy(e){
          let address = this.address;
          this.$copyText(address, this.$t('chongbi.fzcg'));
          this.$toast.center(this.$t('chongbi.fzcg'));
      },
    },
    beforeDestroy(){

    },
    filters: {
      times(timestamp){
        var date = new Date((timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + " " + h + m + s;
      }
    }
}
</script>
<style scoped>
.position-box{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url('../assets/element-background.png') no-repeat center center;
    background-size: cover;
}
  .head {
    position: fixed;
    left: 0;
    top:0;
    right: 0;
    z-index: 10;
    width: 100%;
    display:flex;
    justify-content: center;
    align-items: center;
    padding: .45rem 0 3.36rem;
    color: #fff;
    font-size: .52rem;
}
.head .back{
  position: absolute;
  left: .4rem;
  top: .4rem;
  width: .36rem;
}
.bg{
    position: absolute;
    left: 0;
    top: 66px;
    bottom: 0;
    width: 100%;
    height: auto;
    padding: 14px 14px 48px;
    box-sizing: border-box;
    overflow: scroll;
}
.repayment-head{
    position: relative;
    top: -14px;
    z-index: 90;
    padding: 30px 0 24px;
    background: #131e30;
    border-radius: 9px;
    text-align: center;
}
.repayment-head .t1{
    color: #fff;
    font-size: 14px;
}
.repayment-head .money{
    padding: 22px 0 26px;
    color: #3578FD;
    font-size: 32px;
    font-weight: bold;
}
.repayment-head .tips{
  padding: 0 10px;
  color: #AFAFAF;
  font-size: 12px;
}
.repayment-body{
    margin-top: 5px;
    padding: 16px 12px 36px;
    background: #131e30;
    border-radius: 9px;
}
.repayment-body .text{
    padding-bottom: 6px;
    color: #3578FD;
    font-size: 14px;
}
.repayment-body .li{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    color: #fff;
    font-size: 14px;
}
.repayment-body .btn{
    display: block;
    width: 100%;
    height: 40px;
    margin: 38px 0 0;
    color: #fff;
    font-size: 16px;
    border-radius: 9px;
    line-height: 40px;
    background: #588bf8;
    text-align: center;
}
.repayment-alert{
    position: fixed;
    left: 26px;
    right: 26px;
    top: 50%;
    z-index: 10000;
    width: auto;
    padding: 48px 26px 34px;
    background: #fff;
    border-radius: 9px;
    transform: translateY(-50%);
}
.repayment-alert .title{
    color: #3F3F3F;
    font-size: 18px;
    text-align: center;
}
.repayment-alert .btn{
    display: block;
    width: 100%;
    height: 40px;
    margin: 50px 0 0;
    color: #fff;
    font-size: 16px;
    border-radius: 9px;
    line-height: 40px;
    background: #588bf8;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/repayment2.vue